/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_Bulk_Match_FailedInputs */

const cs_demands_bulk_match_failed = /** @type {(inputs: Demands_Bulk_Match_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hromadné párování selhalo u všech vybraných poptávek.`)
};

const en_demands_bulk_match_failed = /** @type {(inputs: Demands_Bulk_Match_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulk matching failed for all selected demands.`)
};

/**
* | output |
* | --- |
* | "Bulk matching failed for all selected demands." |
*
* @param {Demands_Bulk_Match_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_bulk_match_failed = /** @type {((inputs?: Demands_Bulk_Match_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_Bulk_Match_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_bulk_match_failed(inputs)
	return cs_demands_bulk_match_failed(inputs)
});